// import Quill
import Quill from 'quill/dist/quill.js';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
// Import custom modules
import { ImageImport } from './ImageImport';
import { ImageResize } from './ImageResize';
import { ExpandEditor } from './ExpandEditor';
import { PasteCleaner } from './PasteCleaner';

Quill.register({
	'modules/imageImport': ImageImport,
	'modules/imageResize': ImageResize,
	'modules/expandEditor': ExpandEditor,
	'modules/pasteCleaner': PasteCleaner,
});

export default Quill;
